fx.ns("shared.renderers", class PhotoRenderer extends fx.Component {

	constructor(data) {
		super(data);
	}

	onReady() {
		super.onReady();

		if (fx.browser.isDesktop) {
			this.on("mouseover", this.onMouseOver);
			this.on("mouseout", this.onMouseOut);
		}

		if (this.deleteIcon)
			this.on("click", this.onRemove, this.deleteIcon);

		this.attr("data-id", this.data.id);

        this._processingAnimation();
	}

	hide() {
		super.hide();
	}

	create() {
		this.image = new fx.components.Image({ className: this.data.isHeic && !this.data.uploaded ? "uploading" : "draggable", data: this.data.thumb });
		this.image.attr("data-class", "Photo");
		this.image.attr("data-id", this.data.id);
		this.image.attr("data-behaviour", "add-component");
		// tmp
		this.image.attr("data-width", this.data.width);
		this.image.attr("data-height", this.data.height);
		//this.image.toolTip = fx.text("Déplacer et déposez<br>ou Cliquez  pour ajouter<br>")

		this.addChild(this.image);

		this.usedIcon = new fx.components.Image({ data: fx.assets.used, className: "usedicon", tooltip: fx.text("Photo utilisée") });
		this.usedIcon.visibleAtStart = false;

		this.addChild(this.usedIcon, { top: 0, left: 0, width: 30, height: 30 });

		this.deleteIcon = new fx.components.Image({ data: fx.assets.deleteIcon, className: "delete", tooltip: fx.text("Supprimer") });
		this.deleteIcon.visibleAtStart = false;

		if (fx.get("flutter")) {
			// loading animation for flutter photos. Not "loading" : fx.Component.loading() is a method, which
			// made "if (this.loading)" true everywhere else, and ".hide()" throw on it
			this.loadingAnimation = new fx.components.Box("loading-animation");
			this.addChild(this.loadingAnimation, { width: "100%", height: "100%" });
			this.data.initializing ? this.loadingAnimation.show() : this.loadingAnimation.hide();	// display loading on photos for flutter app, because there is no extracting screen. (initializing field is only set in flutter)
		}

		if (this.data.isHeic && !this.data.uploaded) {
			this.progress = new fx.components.Box("progress");
			this.addChild(this.progress, { width: 0, height: 5, bottom: 0, left: 0 });

			this.waiting = new fx.components.Image({ data: fx.assets.loader, className: "extacting" });
			this.addChild(this.waiting, { width: 30, height: 30, left: "center", top: "center" });

			this.toolTip = fx.text("Veuillez attendre la fin du transfer<br>pour pouvoir utiliser cette photo.");
		}

		this.addChild(this.deleteIcon, { bottom: 0, right: 0, width: 30, height: 30 });
	}

	/*render()
	{
		let html =  '<img class="draggable" data-class="Photo" src="' + this.data.thumb + '" data-id="' + this.data.id + '" data-width="' + this.data.width + '" data-height="' + this.data.height + '" >'
					+ '<div class="usedicon" title="Cette photo est utilisée dans votre ouvrage">' + fx.assets.used.render() + '</div>' 
					+'<div class="delete" title="Supprimer">' + fx.assets.deleteIcon.render() + '</div>';
					return html;
	}*/


	// thumbnail usage indicator. book (desktop + mobile): page-number label (reads this.data.pagesLabel, maintained by BookRepository); other products: blue "photo used" check
	_refreshUsageIndicator()
	{
		if (!this.data)
			return;

		if (fx.get("app") == "book")
		{
			if (!this.pageLabel && this.node)
			{
				// raw DOM span (like .select-circle) to avoid the inline opacity fx.show() sets
				this.pageLabel = document.createElement("span");
				this.pageLabel.className = "page-label";
				this.node.appendChild(this.pageLabel);

				// native HTML title, set only while the cursor is over the (clipped) label, so the
				// browser tooltip reveals the full page list there but never over the rest of the photo
				this._pageTitleSync = this._syncPageTitle.bind(this);
				this.node.addEventListener("mousemove", this._pageTitleSync);
				this.node.addEventListener("mouseleave", this._pageTitleSync);
			}

			if (this.pageLabel)
			{
				let text = this.data.pagesLabel || "";

				if (text)
				{
					this.pageLabel.textContent = text;
					this.pageLabel.style.display = "";
				}
				else
				{
					this.pageLabel.style.display = "none";
					if (this.node) this.node.removeAttribute("title");
				}
			}
			// the blue check is never shown in book mode (usedIcon.visibleAtStart = false)
		}
		else
		if (this.usedIcon)
			this.usedIcon.toggle(this.data.number > 0);
	}

	// drive the tile's native title so the browser tooltip shows the full page list ONLY while the
	// cursor is over the label and that label is either clipped (2-line clamp or ellipsis) or cut
	// down to the first page numbers ("..."). measured live so it is accurate with the virtualised
	// grid; the title carries no cost when the pointer is elsewhere
	_syncPageTitle(e)
	{
		if (!this.pageLabel || !this.node)
			return;

		let shown = (this.data && this.data.pagesLabel) ? this.data.pagesLabel : "";
		let text = (this.data && this.data.pagesLabelFull) ? this.data.pagesLabelFull : shown;
		let overLabel = false;

		if (shown && e && this.pageLabel.style.display != "none")
		{
			let clipped = text != shown ||
			              this.pageLabel.scrollHeight > this.pageLabel.clientHeight + 1 ||
			              this.pageLabel.scrollWidth > this.pageLabel.clientWidth + 1;

			if (clipped)
			{
				let r = this.pageLabel.getBoundingClientRect();
				overLabel = e.clientX >= r.left && e.clientX <= r.right &&
				            e.clientY >= r.top && e.clientY <= r.bottom;
			}
		}

		if (overLabel)
		{
			if (this.node.getAttribute("title") != text)
				this.node.title = text;
		}
		else if (this.node.hasAttribute("title"))
			this.node.removeAttribute("title");
	}


	onDataUpdated(action)
	{
         if (action.model instanceof models.Photo && action.impacts("processing"))
            this._processingAnimation();

		this._refreshUsageIndicator();

		if (action.type == "update") {
			if (this.data.deleted) {
				this.hide();
				return;
			}

			for (let i = 0; i < action.properties.length; i++) {
				if ("width,height,thumb,id".indexOf(action.properties[i]) == -1)
					continue;

				if (action.properties[i] == "initializing") {
					if (this.loadingAnimation) {
						if (!this.data.initializing)
							this.loadingAnimation.hide();
						else
							this.loadingAnimation.show();
					}
				}
				else if (action.properties[i] == "thumb") {
					this.image.src = action.data[action.properties[i]];
				}
				else
					if (action.properties[i] == "id") {
						this.id = action.data[action.properties[i]];
						this.image.attr("data-id", this.id);
					}
					else {
						this.image.attr("data-" + action.properties[i], action.data[action.properties[i]]);
					}
			}
		}
	}

	onDataEvent(event) {
		switch (event.type) {
			case "upload-file-progress":
				if (this.data.isHeic) {
					if (this.progress)
						this.progress.width(this.data.progress + "%");

					if (this.waiting)
						this.waiting.destroy();
				}
				break;

			case "media-file-uploaded":
				// flutter : uploaded before extracted, media-file-extracted never comes
				if (this.loadingAnimation && !this.data.initializing)
					this.loadingAnimation.hide();

				if (this.data.isHeic) {
					this.image.removeClass("uploading");
					this.image.addClass("draggable");
					if (this.progress)
						this.progress.destroy();
					if (this.loadingAnimation)
						this.loadingAnimation.hide();
					this.toolTip = "";
				}
				break;
			case "media-file-extracted":
				// hide loading on flutter app when photo is extracted
				if (this.loadingAnimation)
					this.loadingAnimation.hide();
				break;
			default:
				break;
		}
	}


	onMouseOver() {
		this.deleteIcon.show();
		//this.css(this.deleteIcon, {"opacity" : 1 });
	}

	onMouseOut() {
		this.deleteIcon.hide();
		//this.css(this.deleteIcon, {"opacity" : 0 });
	}

	onRemove(e) {
		e.preventDefault();
		if (typeof e.stopPropagation == "function")
			e.stopPropagation();

		this.data.delete();
	}

     _processingAnimation()
    {
        if (this.data.processing)
        {
            if (!this._processingAnimationContainer)
            {
                this._processingAnimationContainer = new fx.components.ScanBox();
                this.addChild(this._processingAnimationContainer, {top:0, left:0,width:"100%", height:"100%"});
            }
        }
        else
        {
            if (this._processingAnimationContainer)
            {
                this.removeChild(this._processingAnimationContainer, true);
                this._processingAnimationContainer = null;
            }
        }
    }
});